import * as Yup from 'yup';

export const validationSchema = ({ t }) => {
  const isRequired = t('is required');
  const billingInfo = t('Billing info -');
  const valid = t('must be a valid');

  const messages = {
    firstName: `${billingInfo} ${t('First name')} ${isRequired}`,
    lastName: `${billingInfo} ${t('Last name')} ${isRequired}`,
    phone: `${billingInfo} ${t('Phone number')} ${isRequired}`,
    email: `${billingInfo} ${t('Email')} ${isRequired}`,
    address1: `${billingInfo} ${t('Address')} ${isRequired}`,
    city: `${billingInfo} ${t('City')} ${isRequired}`,
    state: `${billingInfo} ${t('State')} ${isRequired}`,
    postalCode: `${billingInfo} ${t('Zip code')} ${isRequired}`,
    country: `${billingInfo} ${t('Country')} ${isRequired}`,
    validPhone: `${billingInfo} ${t('Phone number')} ${valid} ${t('phone')}`,
    validEmail: `${billingInfo} ${t('Email')} ${valid} ${t('email')}`,
    invalidPostalCode: `${t('Zip code')} ${valid} ${t('zip code')}`,
    companyName: `${t('Company')} ${isRequired}`
  };

  return Yup.object().shape({
    name: Yup.string().required(t('Name is required')),
    superUserFirstName: Yup.string()
      .nullable()
      .when('id', {
        is: val => !val,
        then: Yup.string().required(t('First Name is required'))
      }),
    superUserLastName: Yup.string()
      .nullable()
      .when('id', {
        is: val => !val,
        then: Yup.string().required(t('Last Name is required'))
      }),
    superUserLoginEmail: Yup.string()
      .nullable()
      .when('id', {
        is: val => !val,
        then: Yup.string().required(t('Email is required'))
      }),
    config: Yup.object().shape({
      defaultBillingTerms: Yup.object().shape({
        companyName: Yup.string().when(
          '$isThirdPartyBilling',
          (isThirdPartyBilling, schema) => {
            if (isThirdPartyBilling) {
              return schema.required(messages.companyName);
            } else {
              return schema.nullable();
            }
          }
        ),
        addressInfo: Yup.object().shape({
          address1: Yup.string()
            .typeError(messages.address1)
            .when('$isThirdPartyBilling', (isThirdPartyBilling, schema) => {
              if (isThirdPartyBilling) {
                return schema.required(messages.address1);
              } else {
                return schema.nullable();
              }
            }),
          city: Yup.string()
            .typeError(messages.city)
            .when('$isThirdPartyBilling', (isThirdPartyBilling, schema) => {
              if (isThirdPartyBilling) {
                return schema.required(messages.city);
              } else {
                return schema.nullable();
              }
            }),
          state: Yup.string()
            .typeError(messages.state)
            .when('$isThirdPartyBilling', (isThirdPartyBilling, schema) => {
              if (isThirdPartyBilling) {
                return schema.required(messages.state);
              } else {
                return schema.nullable();
              }
            }),
          postalCode: Yup.string()
            .zip(messages.invalidPostalCode)
            .typeError(messages.postalCode)
            .when('$isThirdPartyBilling', (isThirdPartyBilling, schema) => {
              if (isThirdPartyBilling) {
                return schema.required(messages.postalCode);
              } else {
                return schema.nullable();
              }
            }),
          country: Yup.string()
            .typeError(messages.country)
            .when('$isThirdPartyBilling', (isThirdPartyBilling, schema) => {
              if (isThirdPartyBilling) {
                return schema.required(messages.country);
              } else {
                return schema.nullable();
              }
            })
        }),
        contactInfo: Yup.object().shape({
          firstName: Yup.string()
            .typeError(messages.firstName)
            .when('$isThirdPartyBilling', (isThirdPartyBilling, schema) => {
              if (isThirdPartyBilling) {
                return schema.required(messages.firstName);
              } else {
                return schema.nullable();
              }
            }),
          lastName: Yup.string()
            .typeError(messages.lastName)
            .when('$isThirdPartyBilling', (isThirdPartyBilling, schema) => {
              if (isThirdPartyBilling) {
                return schema.required(messages.lastName);
              } else {
                return schema.nullable();
              }
            }),
          phone: Yup.string()
            .phone(messages.validPhone)
            .typeError(messages.phone)
            .when('$isThirdPartyBilling', (isThirdPartyBilling, schema) => {
              if (isThirdPartyBilling) {
                return schema.required(messages.phone);
              } else {
                return schema.nullable();
              }
            }),
          email: Yup.string()
            .email(messages.validEmail)
            .typeError(messages.email)
            .when('$isThirdPartyBilling', (isThirdPartyBilling, schema) => {
              if (isThirdPartyBilling) {
                return schema.required(messages.email);
              } else {
                return schema.nullable();
              }
            })
        })
      })
    })
  });
};

export default validationSchema;
